const FormResources = {
    form_data:
    {
        status_id: '',
        role_id: '',
        permissions_template_id: '',
        reports_to: '',
        country_id: '',
        state: '',
        city: '',
        position_id: '',
        shift_id: '',
        department_id: '',
        contact_type_id: '',
        include_in_supervisor_lists: false,
        confirmation_fields: [],
    },

    form_format:
    [
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Status',
            ref: 'status_id',
            ref_alt: 'status_id_alt',
            model_name: 'status_id',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Role',
            ref: 'role_id',
            ref_alt: 'role_id_alt',
            model_name: 'role_id',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Permissions Template',
            ref: 'permissions_template_id',
            ref_alt: 'permissions_template_id_alt',
            model_name: 'permissions_template_id',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Reports to',
            ref: 'reports_to',
            ref_alt: 'reports_to_alt',
            model_name: 'reports_to',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Country',
            ref: 'country_id',
            ref_alt: 'country_id_alt',
            model_name: 'country_id',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'text',
            maxlength: '',
            disabled: false,
            step: '',
            name:'State',
            ref: 'state',
            ref_alt: 'state_alt',
            model_name: 'state',
            required: false  
        },
        {
            city: '',
            css_class: 'col-md-3',
            type: 'text',
            maxlength: 80,
            disabled: false,
            step: '',
            name: 'City',
            ref: 'city',
            ref_alt: 'city_alt',
            model_name: 'city',
            required: false, 
        },
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Position',
            ref: 'position_id',
            ref_alt: 'position_id_alt',
            model_name: 'position_id',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Shift',
            ref: 'shift_id',
            ref_alt: 'shift_id_alt',
            model_name: 'shift_id',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Department',
            ref: 'department_id',
            ref_alt: 'department_id_alt',
            model_name: 'department_id',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'select',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Contact Type',
            ref: 'contact_type_id',
            ref_alt: 'contact_type_id_alt',
            model_name: 'contact_type_id',
            required: false
        },
        {
            css_class: 'col-md-3',
            type: 'checkbox',
            maxlength: '',
            disabled: false,
            step: '',
            name:  'Include in supervisor lists',
            ref: 'include_in_supervisor_lists',
            ref_alt: 'include_in_supervisor_lists_alt',
            model_name: 'include_in_supervisor_lists',
            required: false
        },
    ],

    confirmation_form_format:[
        {
            css_class:  'col-md-3',
            label_class: 'w-100',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'P. Template',
            ref:        'permissions_template_id',
            model_name: 'confirmation_fields',
            value:      'permissions_template_id',
            ref_alt:    'permissions_template_id_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            label_class: 'w-100',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'State',
            ref:        'state_input',
            model_name: 'confirmation_fields',
            value:      'state',
            ref_alt:    'state_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            label_class: 'w-100',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'City',
            ref:        'city_input',
            model_name: 'confirmation_fields',
            value:      'city',
            ref_alt:    'city_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            label_class: 'w-100',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Position',
            ref:        'position_input',
            model_name: 'confirmation_fields',
            value:      'position',
            ref_alt:    'position_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            label_class: 'w-100',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Shift',
            ref:        'shift_input',
            model_name: 'confirmation_fields',
            value:      'shift',
            ref_alt:    'shift_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            label_class: 'w-100',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Department',
            ref:        'department_input',
            model_name: 'confirmation_fields',
            value:      'department',
            ref_alt:    'department_input_alt',
            required:   false,
        },
        {
            css_class:  'col-md-3',
            label_class: 'w-100',
            type:       'checkbox',
            maxlength:  null,
            disabled:   false,
            step:       null,
            name:       'Contact type',
            ref:        'contact_type_input',
            model_name: 'confirmation_fields',
            value:      'contact_type',
            ref_alt:    'contact_type_input_alt',
            required:   false,
        },
        {
            css_class: 'col-md-5',
            label_class: 'w-100',
            type: 'checkbox',
            maxlength: null,
            disabled: false,
            step: null,
            name:  'Include in supervisor lists',
            ref: 'include_in_supervisor_lists',
            value: 'include_in_supervisor_lists',
            ref_alt: 'include_in_supervisor_lists_alt',
            model_name: 'confirmation_fields',
            required: false
        },
    ],

    statuses:
    [
        {
            id: 1, 
            name: 'Active'
        },
        {
            id: 0, 
            name: 'Inactive'
        }
    ],

    shifts:
    [
        {
            id: 1, 
            name: 'Day'
        },
        {
            id: 2, 
            name: 'Evening'
        },
        {
            id: 3, 
            name: 'Night'
        }
    ]

}

export default FormResources